import styled, { css } from 'styled-components';
import { themeGet } from '@styled-system/theme-get';

import Ctas from '../../../Core/Ctas';

export const Section = styled.div`
  display: flex;
  justify-content: center;
  background: ${({ $backgroundColor }) =>
    $backgroundColor ? themeGet(`colors.${$backgroundColor}`) : 'transparent'};
  background-image: url(${({ $backgroundImage }) =>
    $backgroundImage ? $backgroundImage.asset.localImage.publicURL : ''});
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  ${({ $backgroundColor }) =>
    $backgroundColor &&
    css`
      padding: 3.5rem 0;
    `}
  margin: 40px auto;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    margin: 70px auto;
  }

  @media only screen and (min-width: ${themeGet('breakpoints.xlg')}) {
    margin: 100px auto;
  }
  &.card-comparison {
    flex-direction: column;
  }
`;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: ${themeGet('media.grid')};
  width: calc(100% - ${themeGet('media.grid-gutter.2')});

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.4')});
  }

  @media only screen and (min-width: ${themeGet('breakpoints.lg')}) {
    width: calc(100% - ${themeGet('media.grid-gutter.5')});
  }

  ${Section}.card-comparison & {
    width: 100%;
  }
`;

export const Interests = styled.div`
  padding: 0;
  margin: 1rem 0;
  display: grid;
  flex-wrap: wrap;
  justify-content: center;
  gap: 2.25rem;
  grid-template-columns: 1fr;

  @media only screen and (min-width: ${themeGet('breakpoints.md')}) {
    grid-template-columns: repeat(${props => props.$interestLength}, 1fr);
  }

  ${Section}.card-comparison & {
    margin: 0.5rem 0 1rem;
    gap: 1rem 0.5rem;
    padding: 0 1.5rem;
    grid-template-columns: repeat(2, 1fr);
  }
`;

export const Interest = styled.div`
  display: grid;
  width: 100%;
  grid-template-rows: subgrid;
  grid-row: auto / span 2;
  gap: 0.5rem;

  ${Section}.card-comparison & {
    display: unset;
    grid-row: unset;
  }
`;

export const Header = styled.p`
  font-size: 1.5rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 150%;
  color: ${({ theme, $headingColor }) =>
    $headingColor
      ? theme.colors[`${$headingColor}`]
      : theme.colors[`main-text`]};

  ${Section}.card-comparison & {
    font-size: 1rem;
  }
`;

export const InterestRate = styled.p`
  font-size: 1.125rem;
  ${Section}.card-comparison & {
    font-size: 1rem;
    color: ${themeGet('colors.grey-text')};
    span {
      color: ${themeGet('colors.grey-text')};
    }
  }
`;

export const StyledCtas = styled(Ctas)`
  ${Section}.velvet & {
    a {
      color: ${({ theme }) => theme.colors.white};
      &:hover,
      &:focus {
        color: ${({ theme }) => theme.colors['pc-red']};
      }
    }
  }
`;

export const HeadingSection = styled.div`
  display: none;
  ${Section}.card-comparison & {
    display: unset;
    margin: 0 1.5rem;
  }
`;

export const Title = styled.p`
  font-size: 1.25rem;
  font-weight: ${themeGet('fontWeights.medium')};
  line-height: 150%;
`;
